import { Component, OnInit } from '@angular/core';
import { UpdateHandler } from '../app/core/services/update-handler.service';
import { AuthService } from './core/services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  isSessionSwitching = false;

  constructor(
    updateHandler: UpdateHandler,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    // Check if we're in the middle of a session switch
    this.isSessionSwitching = this.authService.isSessionSwitching();

    if (this.isSessionSwitching) {
      // Clear the flag after 2 seconds to ensure page is fully loaded
      setTimeout(() => {
        this.authService.setSessionSwitching(false);
        this.isSessionSwitching = false;
      }, 2000);
    }

    console.log('10.06 Deploy Test')
  }

  title = 'fi-galaxy';
  notifierOptions: any = {
    animate: 'fromTop',
    position: ['top', 'right'],
    clickToClose: true,
    maxStack: 1,
    timeOut: 5000,
  };
}
